import { Component, OnInit, ChangeDetectionStrategy, Inject, OnDestroy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as moment from 'moment';
import { BehaviorSubject, from, Observable, Subscription } from 'rxjs';
import { catchError, map, mergeMap, tap, toArray } from 'rxjs/operators';
import { CustomAlertService } from 'src/app/_components/custom-alert/custom-alert.service';
import { ComentariosService } from 'src/app/_components/glm-comentarios/comentarios.service';
import { Comentario } from 'src/app/_models/comentario';
import { ClassroomService } from 'src/app/_services/classroom.service';
import { RetroalimentacionService } from '../retroalimentacion/_services/retroalimentacion.service';

@Component({
  selector: 'app-retroalimentacion-devolver-dialogo',
  standalone: false,
  templateUrl: './retroalimentacion-devolver-dialogo.component.html',
  styleUrls: ['./retroalimentacion-devolver-dialogo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RetroalimentacionDevolverDialogoComponent implements OnInit, OnDestroy {

  datosAlumnos: any[];
  alumnos: any[];
  accion: string;
  evento$: Observable<any>;
  unidadEventoMateriaIds;

  mensaje = new UntypedFormControl('', Validators.required);
  email = new UntypedFormControl(false);

  savingSubject = new BehaviorSubject<boolean>(false);
  saving$ = this.savingSubject.asObservable();

  dataAlumnosSubscription: Subscription;

  eventoMateriasIds: string;

  configuracionForm = new UntypedFormGroup({
    requiereAutoevaluacion: new UntypedFormControl(false),
    requiereAutoevaluacionComentario: new UntypedFormControl(false),
    mostrarEvidenciaDetalle: new UntypedFormControl(false),
    mostrarColoresEscala: new UntypedFormControl(false),
    mostrarComentarioProfesorAntes: new UntypedFormControl(true),
    mostrarRubrica: new UntypedFormControl(false)
  });

  constructor(
    public dialogRef: MatDialogRef<RetroalimentacionDevolverDialogoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private classroomService: ClassroomService,
    private snackBar: MatSnackBar,
    private customAlert: CustomAlertService,
    private retroalimentacionService: RetroalimentacionService,
    private comentariosService: ComentariosService
  ) { }

  ngOnInit(): void {
    this.alumnos = this.data.alumnos;
    this.accion = this.data.accion;
    this.evento$ = this.data.evento.pipe(
      tap(data => {
        this.eventoMateriasIds = this.retroalimentacionService.filterEventoMaterias(data, this.data.fecha, this.data.materia)
          .map(item => item.id).join(',');
      })
    );

    this.dataAlumnosSubscription = this.data.datosAlumnos.subscribe(res => {
      this.datosAlumnos = this.alumnos.map(id => res.find(alumno => alumno.id === id));
      if (this.datosAlumnos.length === 1 && this.datosAlumnos[0]['eventoMateriaAlumnoConfig'] && this.datosAlumnos[0]['eventoMateriaAlumnoConfig'].id !== 0) {
        this.configuracionForm.setValue({
          requiereAutoevaluacion: this.datosAlumnos[0]['eventoMateriaAlumnoConfig'].requiereAutoevaluacion,
          requiereAutoevaluacionComentario: this.datosAlumnos[0]['eventoMateriaAlumnoConfig'].requiereAutoevaluacionComentario,
          mostrarEvidenciaDetalle: this.datosAlumnos[0]['eventoMateriaAlumnoConfig'].mostrarEvidenciaDetalle,
          mostrarColoresEscala: this.datosAlumnos[0]['eventoMateriaAlumnoConfig'].mostrarColoresEscala,
          mostrarComentarioProfesorAntes: this.datosAlumnos[0]['eventoMateriaAlumnoConfig'].mostrarComentarioProfesorAntes,
          mostrarRubrica: this.datosAlumnos[0]['eventoMateriaAlumnoConfig'].mostrarRubrica || false
        });
      }
      this.unidadEventoMateriaIds = [...new Set(this.datosAlumnos.map(item => item.unidadEventoMateriaId))];
    });
  }

  submit(accion: string) {
    this.savingSubject.next(true);

    if (accion === 'comevntar')  {
      const modelo = {
        comentario: new Comentario({
          id: '0',
          comentario: this.mensaje.value,
          fecha: moment().format()
        }), targetID: this.datosAlumnos[0].eventoMateriaAlumnoId, tipo: 'unidadeventoalumno'
      };
      return this.comentariosService.guardarComentario(modelo).subscribe(res => {
        this.savingSubject.next(false);
          this.dialogRef.close();
          this.snackBar.open(`La evaluación del estudiante fue comentada`, '', { duration: 2500});
      },  err => {
        this.savingSubject.next(false);
        this.customAlert.setCustomMessage({
          tipo: 'error',
          texto: `Error al ${this.accion} la evaluación. ${err.error}`
        });
      });
    } else {
      from(this.unidadEventoMateriaIds).pipe(
        mergeMap(id => {
            return this.classroomService.classroomReturnV2(this.datosAlumnos.filter(item =>
              item.unidadEventoMateriaId === id), this.accion, this.mensaje.value, id, this.email.value,
              this.accion === 'publicar' ? this.configuracionForm.value : undefined).pipe(
              catchError(err => {
                this.savingSubject.next(false);
                this.customAlert.setCustomMessage({
                  tipo: 'error',
                  texto: `Error al ${this.accion} la evaluación. ${err.error}`
                });
                return [];
              })
            );
        }),
        toArray(),
        map(data => {
          let resp = [];
          data.forEach(item => {
            resp = resp.concat(item);
          });
          return resp;
        })
      ).subscribe(
        res => {
          this.savingSubject.next(false);
          this.dialogRef.close();
          if (res.length > 0) {
            this.snackBar.open(`La evaluación fue ${this.accion === 'publicadar' ? 'publicada' : ( this.accion === 'despublicar' ? 'despublicada' : 'comentada' ) }
              a${this.alumnos.length === 1 ? 'l estudiante' : ' los estudiantes.'}`, '', { duration: 2500});
          }
        },
        err => {
          this.savingSubject.next(false);
          this.customAlert.setCustomMessage({
            tipo: 'error',
            texto: `Error al ${this.accion} la evaluación. ${err.error}`
          });
        }
      );
    }
  }

  ngOnDestroy(): void {
    if (this.dataAlumnosSubscription) {
      this.dataAlumnosSubscription.unsubscribe();
    }
  }

}
